import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/filter';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  public currentLanguage: string;
  public currentUrl: string;
  private routeData: any;

constructor(private translate: TranslateService, private router: Router, private route: ActivatedRoute) {

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('hr');

    router.events.subscribe((event) => {
      // scroll to top on route change
      if (event instanceof NavigationEnd) {
        // window.scrollTo(0, 0);
        this.currentUrl = event.url;
      }
    });

    this.currentLanguage = translate.defaultLang;

    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.currentLanguage = event.lang;
    });

  }

  /**
   * Change language
   * @param language is 'en' OR 'hr'
   */
  public changeLanguage(language: string) {
    // 1. change language
    this.translate.use(language);
    this.currentLanguage = language;

    // 2. go to complement state in changed language
    this.router.navigate(['/' + this.routeData.config[language]]);
  }

  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(event => {
        let currentRoute = this.route.root;
        while (currentRoute.children[0] !== undefined) {
          currentRoute = currentRoute.children[0];
        }

        this.routeData = currentRoute.snapshot.data;
      });
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts